import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

class CardRePrintTail extends Component {
  constructor () {
    super();
    this.state = {
      status: '0',
      count: 0
    };
  }

  componentDidMount () {
  }

  viewDetails() {

    if (AuthenticationService.isKhac()){  
      this.props.history.push("/prt?caller=1");
      return;
    } 
  }

  render() {
    return(
      <Card style={{ width: '18rem' }}>
        <Card.Body>
          <Card.Title> { couterpart.translate('reprint_tail_khac_title') } </Card.Title>
          <Card.Text>
            { couterpart.translate('reprint_tail_khac_desc') }
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button>
        </Card.Body>
      </Card>        
    );
  }
}

export default withRouter(CardRePrintTail);